import { Tabs, Tab, Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import "./pannel.css";

const SideBar = ({ value, handleChange }) => {
  const TabProps = (index) => {
    return {
      id: `sidebar-tab-${index}`,
      "aria-controls": `tabpanel-${index}`,
    };
  };

  return (
    <div className="side-bar">
      <Grid container>
        <Box
          sx={{
            flexGrow: 1,
            maxWidth: { xs: 320, sm: 1600 },
          }}
        >
          <Tabs
            direction="left"
            textColor="inherit"
            orientation="horizontal"
            variant="scrollable"
            // scrollButton="auto"
            allowScrollButtonsMobile
            value={value}
            onChange={handleChange}
          >
            <Tab
              className="tabs"
              label="واحد خدمات فنی و مهندسی"
              {...TabProps(0)}
              sx={{ fontSize: "1.2rem" }}
            ></Tab>
            <Tab
              className="tabs"
              label="واحد مهندسی فروش"
              {...TabProps(1)}
              sx={{ fontSize: "1.2rem" }}
            ></Tab>

            <Tab
              className="tabs"
              label=" واحد آموزش"
              {...TabProps(3)}
              sx={{ fontSize: "1.2rem" }}
            ></Tab>
          </Tabs>
        </Box>
      </Grid>
    </div>
  );
};
export default SideBar;
